"use client";

import { useEffect, useRef, useState } from "react";
import Button from "@/app/components/ui/Button/Button.jsx";
import styles from "./help.module.css";

export default function ArticleCodeBlock({ code, language = "" }) {
  const [copyState, setCopyState] = useState("idle");
  const resetTimer = useRef(null);

  useEffect(() => () => clearTimeout(resetTimer.current), []);

  async function copyCode() {
    clearTimeout(resetTimer.current);
    try {
      await navigator.clipboard.writeText(code);
      setCopyState("copied");
      resetTimer.current = setTimeout(() => setCopyState("idle"), 2000);
    } catch {
      setCopyState("error");
    }
  }

  return (
    <div className={styles.codeExample}>
      <div className={styles.codeExampleHeader}>
        <span>{language.toUpperCase() || "Code"}</span>
        <Button type="button" variant="secondary" size="sm" onClick={copyCode}>
          {copyState === "copied" ? "Copied!" : language === "html" ? "Copy script" : "Copy code"}
        </Button>
      </div>
      <pre className={styles.codeBlock} tabIndex={0} aria-label="Code to copy">
        <code>{code}</code>
      </pre>
      <p role="status" className={copyState === "error" ? styles.copyCodeError : styles.visuallyHidden}>
        {copyState === "error"
          ? "Couldn’t copy automatically. Select the code above and copy it manually."
          : copyState === "copied" ? "Code copied to clipboard." : ""}
      </p>
    </div>
  );
}
